export default {
  S22X_P1: 0, 
  S22X_P2: 1, 
};
